"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditorFactory_1 = require("../EditorFactory");
const Node_1 = require("../Node");
const React = require("react");
const core_1 = require("@blueprintjs/core");
const mobx_1 = require("mobx");
const createDefaultNode_1 = require("../createDefaultNode");
const mobx_react_1 = require("mobx-react");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const UnionSelector_1 = require("./UnionSelector");
class ArrayEditorFactory extends EditorFactory_1.EditorFactory {
    getEditors(node, factory, context) {
        if (node.kind !== "array") {
            return [];
        }
        return [
            {
                isSingleLine: false,
                priority: 100,
                render: () => (React.createElement(ArrayEditor, { node: node, factory: factory, context: context }))
            }
        ];
    }
}
exports.ArrayEditorFactory = ArrayEditorFactory;
let ArrayEditor = class ArrayEditor extends React.Component {
    addItem() {
        const c = new Node_1.NodeContainer(this.props.node.actualType.itemType);
        c.node = createDefaultNode_1.createDefaultNode(c.expectedType);
        this.props.node.items.push(c);
    }
    render() {
        const { node, factory, context } = this.props;
        const children = node.items.map((v, idx) => (React.createElement(ArrayEditorItem, { key: idx, idx: idx, container: v, removeItem: () => node.items.splice(idx, 1), factory: factory, context: context })));
        return (React.createElement("div", { className: "component-ArrayEditor" },
            React.createElement("div", { className: "part-header" },
                React.createElement(core_1.Button, { minimal: true, small: true, onClick: this.addItem },
                    React.createElement(core_1.Icon, { icon: "plus", iconSize: 20, color: "black" }))),
            React.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: result => {
                    mobx_1.runInAction(() => {
                        if (!result.destination) {
                            return;
                        }
                        const items = this.props.node.items.splice(result.source.index, 1);
                        this.props.node.items.splice(result.destination.index, 0, ...items);
                        result.source.index;
                    });
                } },
                React.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "droppable" }, provided => (React.createElement("div", Object.assign({}, provided.droppableProps, { ref: provided.innerRef }),
                    children,
                    provided.placeholder))))));
    }
};
__decorate([
    mobx_1.action.bound
], ArrayEditor.prototype, "addItem", null);
ArrayEditor = __decorate([
    mobx_react_1.observer
], ArrayEditor);
let ArrayEditorItem = class ArrayEditorItem extends React.Component {
    removeItem() {
        this.props.removeItem();
    }
    render() {
        const { container, factory, context, idx } = this.props;
        const types = container.expectedType.resolveUnion();
        // assert types.length > 0
        const inner = container.node
            ? factory.getBestEditor(container.node, factory, context)
            : undefined;
        const innerEditor = inner && inner.render();
        return (React.createElement(react_beautiful_dnd_1.Draggable, { draggableId: "" + idx, index: idx }, provided => (React.createElement("div", Object.assign({ className: "component-ArrayEditorItem", ref: provided.innerRef }, provided.draggableProps),
            React.createElement("div", Object.assign({ className: "part-side" }, provided.dragHandleProps),
                React.createElement(core_1.Button, { small: true, minimal: true, onClick: this.removeItem },
                    React.createElement(core_1.Icon, { icon: "remove", iconSize: 18, color: "white" }))),
            React.createElement("div", { className: "part-main" },
                types.length > 1 && (React.createElement("div", { className: "part-type" },
                    React.createElement(UnionSelector_1.UnionSelector, { container: container }, name => (React.createElement("h3", { className: "type-name bp3-heading" }, name))))),
                React.createElement("div", null, innerEditor))))));
    }
};
__decorate([
    mobx_1.action.bound
], ArrayEditorItem.prototype, "removeItem", null);
ArrayEditorItem = __decorate([
    mobx_react_1.observer
], ArrayEditorItem);
//# sourceMappingURL=ArrayEditorFactory.js.map